import Range from './Slider';
export { Range };
export default Range;
